module.exports = __webpack_public_path__ + "img/bjx_detail_table_02.15826cb6.png";